'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const TickIncrementCalculator=require('../../../../../../dist-es6/client/directives/plotting/tickIncrementCalculator');let

IncidentBucketType=class IncidentBucketType{
constructor(label,propertyOnIncidentVM,createInitialBucketViewData,getDomain,getTickInfo){
_.ensureInstanceOf('function',getTickInfo);

this._label=label;
this._propertyOnIncidentVM=propertyOnIncidentVM;
this._createInitialBucketViewData=createInitialBucketViewData;
this._getDomain=getDomain;
this._getTickInfo=getTickInfo;

this._previousBucketGenerationArgs={
timezone:null,
interval:null};


this._previouslyGeneratedInitialViewData=null;
}

get label(){
return this._label;
}

getTickInfo(interval,widthOnScreen){
return this._getTickInfo(interval,widthOnScreen);
}

getBucketFor(incident){
return incident[this._propertyOnIncidentVM];
}

getDomain(interval){
return this._getDomain(interval);
}

getAllBuckets(interval,timezone){
return this.getAllBucketsWithInitialViewData(interval,timezone,{skipSizes:!0}).buckets;
}

getBucketIndexMap(interval,timezone){
return this.getAllBucketsWithInitialViewData(interval,timezone,{skipSizes:!0}).bucketIndexMap;
}

getAllBucketsWithInitialViewData(interval,timezone,options){
if(!this._hasExistingDataAndSameGenerationArgs(interval,timezone)){
this._previouslyGeneratedInitialViewData=this._createInitialBucketViewData(interval,timezone);
this._previousBucketGenerationArgs.interval=interval;
this._previousBucketGenerationArgs.timezone=timezone;
}

return this._getCleanInitialViewData(options);
}

_hasExistingDataAndSameGenerationArgs(interval,timezone){
return _.exists(this._previouslyGeneratedInitialViewData)&&
this._previousBucketGenerationArgs.interval.equals(interval)&&
this._previousBucketGenerationArgs.timezone===timezone;
}

_getCleanInitialViewData({skipSizes=!1}={}){
return{
buckets:this._previouslyGeneratedInitialViewData.buckets,
bucketIndexMap:this._previouslyGeneratedInitialViewData.bucketIndexMap,
bucketSizes:skipSizes?null:Array.from(this._previouslyGeneratedInitialViewData.bucketSizes,_.clone)};

}

static fromConfig({label,propertyOnIncidentVM,createInitialBucketViewData,getDomain,getTickInfo}){
return new IncidentBucketType(label,propertyOnIncidentVM,createInitialBucketViewData,getDomain,getTickInfo);
}

static getBucketTypes({use24HourTimeline=!1}={}){
return use24HourTimeline?
AllTypesWith24HourLabels:
AllTypesWith12HourLabels;
}

static get Types(){
return Types;
}};


const epoch=new Date(0);

const _byDateTickIncrementCalculator=new TickIncrementCalculator([{
interval:'days',
steps:[1,2,8,14]},
{
interval:'months',
steps:[1,3,6]},
{
interval:'years',
steps:[1,2,5,10,50,100]}]);


function _getByDateMinorTickFormatterFor(tickInfo){
switch(tickInfo.interval){
case'days':
if(tickInfo.step===14){
return date=>{
if(date.getDate()>28){
return'';
}
return d3.time.format('%d')(date);
};
}else{
return'%d';
}
case'months':
return'%b';
case'years':
return'%Y';
default:
return'';}

}

function _generateFirstTickOrFirstOfPeriodFormatter(shouldSqueezeInAsFirstTick,isFirstOfPeriod,formatState,formatString){
const d3Formatter=d3.time.format(formatString);
return date=>{
if(!formatState.sawFirstTick){
formatState.sawFirstTick=!0;
if(isFirstOfPeriod(date)||shouldSqueezeInAsFirstTick(date)){
return d3Formatter(date);
}
}else if(isFirstOfPeriod(date)){
formatState.sawFirstTick=!0;
return d3Formatter(date);
}
return'';
};
}

function _getByDateMajorTickFormatterFor(tickInfo,formatState){
switch(tickInfo.interval){
case'days':
return _generateFirstTickOrFirstOfPeriodFormatter(
d=>tickInfo.step<8&&d.getDate()<27,
d=>d.getDate()===1,
formatState,
'%b');
case'months':
return _generateFirstTickOrFirstOfPeriodFormatter(
d=>tickInfo.step<3&&d.getMonth()<10,
d=>d.getMonth()===0,
formatState,
'%Y');
case'years':
return'';}

}

const dateBucketTypeConfig={
label:'Date',
propertyOnIncidentVM:'dateString',
createInitialBucketViewData:(interval,timezone)=>{
const spanningIntervals=interval.getSpanningIntervals('days',1,timezone);
const numBuckets=spanningIntervals.length;

const buckets=new Array(numBuckets);
const bucketSizes=new Array(numBuckets);
const bucketIndexMap=new Map;
for(let i=0;i<numBuckets;i++){
const bucket=Formatters.formatInLocale(spanningIntervals[i].start,'YYYY-MM-DD',timezone,{displayTimeZone:!1});
buckets[i]=bucket;
bucketSizes[i]=fourZeroes();
bucketIndexMap.set(bucket,i);
}

return{
buckets,
bucketIndexMap,
bucketSizes};

},
getDomain:interval=>[d3.time.day(interval.start),d3.time.day(interval.end)],
getTickInfo:(interval,widthOnScreen)=>{
const idealPixelsPerMinorTick=32;
const idealTicks=widthOnScreen/idealPixelsPerMinorTick;
const calculated=_byDateTickIncrementCalculator.calculate(interval.duration,idealTicks);

const formatState={};
const tickStuff={
major:{
ticks:d3.time[calculated.minor.interval],
step:calculated.minor.step,
format:_getByDateMajorTickFormatterFor(calculated.minor,formatState)},

minor:{
ticks:d3.time[calculated.minor.interval],
step:calculated.minor.step,
format:_getByDateMinorTickFormatterFor(calculated.minor)}};



return tickStuff;
}};


const fourZeroes=()=>[0,0,0,0];

const numTimeOfDayBuckets=24;
const timeOfDayBuckets=new Array(numTimeOfDayBuckets);
const timeOfDayBucketSizes=new Array(numTimeOfDayBuckets);
const timeOfDayBucketsIndexMap=new Map;
for(let i=0;i<numTimeOfDayBuckets;i++){
const bucket=_.padStart(i.toString(),2,'0')+':00';
timeOfDayBuckets[i]=bucket;
timeOfDayBucketSizes[i]=fourZeroes();
timeOfDayBucketsIndexMap.set(bucket,i);
}

const timeOfDayInterval=TimeInterval.from(d3.time.day(epoch)).spanning(timespan.fromHours(23));
const timeOfDayBucketDomain=[timeOfDayInterval.start,timeOfDayInterval.end];
const timeOfDay12HourMinorTickConfig={
ticks:d3.time.hour,
step:2,
format:'%I:%M'};


const timeOfDay12HourBucketTypeConfig={
label:'Time of Day',
propertyOnIncidentVM:'hourString',
createInitialBucketViewData:()=>{
return{
buckets:timeOfDayBuckets,
bucketSizes:timeOfDayBucketSizes,
bucketIndexMap:timeOfDayBucketsIndexMap};

},
getDomain:()=>timeOfDayBucketDomain,
getTickInfo:(interval,widthOnScreen)=>({minor:timeOfDay12HourMinorTickConfig})};


const timeOfDay24HourMinorTickConfig=_.defaults({
format:'%H:%M'},
timeOfDay12HourMinorTickConfig);

const timeOfDay24HourBucketTypeConfig=_.defaults({
getTickInfo:(interval,widthOnScreen)=>({
minor:timeOfDay24HourMinorTickConfig})},

timeOfDay12HourBucketTypeConfig);

const dayOfWeekBuckets=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const dayOfWeekBucketSizes=[
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes()];

const dayOfWeekBucketsIndexMap=new Map([
[dayOfWeekBuckets[0],0],
[dayOfWeekBuckets[1],1],
[dayOfWeekBuckets[2],2],
[dayOfWeekBuckets[3],3],
[dayOfWeekBuckets[4],4],
[dayOfWeekBuckets[5],5],
[dayOfWeekBuckets[6],6]]);

const dayOfWeekInterval=TimeInterval.from(d3.time.week(epoch)).spanning(timespan.fromDays(6));
const dayOfWeekBucketDomain=[dayOfWeekInterval.start,dayOfWeekInterval.end];
const dayOfWeekBucketTypeConfig={
label:'Day of Week',
propertyOnIncidentVM:'dayOfWeek',
createInitialBucketViewData:()=>{
return{
buckets:dayOfWeekBuckets,
bucketSizes:dayOfWeekBucketSizes,
bucketIndexMap:dayOfWeekBucketsIndexMap};

},
getDomain:()=>dayOfWeekBucketDomain,
getTickInfo:(interval,widthOnScreen)=>({
minor:{
ticks:d3.time.day,
format:date=>d3.time.format('%a')(date).toUpperCase()}})};




const Types={
Date:IncidentBucketType.fromConfig(dateBucketTypeConfig),
TimeOfDay12Hour:IncidentBucketType.fromConfig(timeOfDay12HourBucketTypeConfig),
TimeOfDay24Hour:IncidentBucketType.fromConfig(timeOfDay24HourBucketTypeConfig),
DayOfWeek:IncidentBucketType.fromConfig(dayOfWeekBucketTypeConfig)};


const AllTypesWith12HourLabels=[Types.Date,Types.TimeOfDay12Hour,Types.DayOfWeek];
const AllTypesWith24HourLabels=[Types.Date,Types.TimeOfDay24Hour,Types.DayOfWeek];

module.exports=IncidentBucketType;
//# sourceMappingURL=incidentBucketTypes.js.map
